import React, { useEffect, useState } from 'react';
import {
  SxProps,
  ToggleButton as MUIToggleButton,
  useTheme,
} from '@mui/material';

interface ToggleButtonProps {
  questionKey: string;
  label: string;
  data: any;
  onAnswerSelect: any;
  responseValue: string | boolean;
  type?: 'standard' | 'symptoms' | 'monthsInReverse' | 'disabled';
  size?: 'small' | 'medium' | 'large';
  sx?: SxProps;
  selected?: boolean;
}

export function ToggleButtonMultipleSelection({
  data,
  onAnswerSelect,
  questionKey,
  label,
  responseValue,
  type,
  size,
  sx,
  selected,
}: ToggleButtonProps) {
  const theme = useTheme();
  const [isSelected, setIsSelected] = useState(false);

  const setResponse = () => {
    setIsSelected(!isSelected);
    onAnswerSelect(questionKey, responseValue);
  };

  useEffect(() => {
    if (type === 'standard') {
      if (data?.includes(label)) {
        setIsSelected(true);
      }
    }
    if (type === 'monthsInReverse') {
      if (data?.includes(label)) {
        setIsSelected(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <MUIToggleButton
      aria-label={label}
      value={label}
      selected={selected || isSelected}
      onClick={setResponse}
      disabled={type === 'disabled'}
      size={size}
      sx={{
        '&.Mui-selected, &.Mui-selected:hover': {
          color: theme.palette.primary.contrastText,
          backgroundColor: theme.palette.primary.light,
          opacity: 0.8,
        },
        ...sx,
      }}
    >
      {label}
    </MUIToggleButton>
  );
}
